import profile from '../../content/profile.json'

export function loadProfile() {
  return profile
}
